import KeenSlider from 'keen-slider'

window.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('section.slider .keen-slider')

	sliders.forEach(sliderEl => {
		const dots = sliderEl.parentElement.querySelectorAll('.dot')
		const totalSlides = parseInt(sliderEl.dataset.totalSlides)

		var slider = new KeenSlider(
			sliderEl,
			{
				breakpoints: {
					'(min-width: 512px)': {
						slides: {
							origin: 'center',
							perView: 'auto',
							spacing: 24,
						},
					},
				},
				slides: {
					origin: 'center',
					perView: 'auto',
					spacing: 16,
				},
				loop: true,
				defaultAnimation: {
					duration: 800,
				},
			},
			[
				slider => {
					let timeout
					let mouseOver = false
					function clearNextTimeout() {
						clearTimeout(timeout)
					}
					function nextTimeout() {
						clearTimeout(timeout)
						if (mouseOver) return
						timeout = setTimeout(() => {
							slider.next()
						}, 5000)
					}
					slider.on('created', () => {
						slider.container.addEventListener('mouseover', () => {
							mouseOver = true
							clearNextTimeout()
						})
						slider.container.addEventListener('mouseout', () => {
							mouseOver = false
							nextTimeout()
						})
						nextTimeout()
					})
					slider.on('dragStarted', clearNextTimeout)
					slider.on('animationEnded', nextTimeout)
					slider.on('updated', nextTimeout)
				},
			]
		)

		dots.forEach(dot => {
			dot.addEventListener('click', () => {
				let targetSlide = parseInt(dot.dataset.slideIndex)
				const currSlide = slider.track.details.rel

				if (targetSlide == currSlide % totalSlides) {
					return
				}

				dots.forEach(d => {
					d.classList.remove('active')
				})
				dot.classList.add('active')

				if (currSlide > totalSlides) {
					targetSlide = totalSlides + targetSlide
				}

				slider.moveToIdx(targetSlide)
			})
		})

		slider.on('slideChanged', () => {
			let targetSlide = slider.track.details.rel % totalSlides

			dots.forEach(dot => {
				dot.classList.remove('active')
			})

			dots[targetSlide].classList.add('active')
		})

		// Reset slider when out of view
		const reset = (entries, observer) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) {
					slider.moveToIdx(0)
				}
			})
		}
		const observer = new IntersectionObserver(reset)

		observer.observe(sliderEl)
	})
})
